export class DefaultProductCatalogConfig {
    constructor(requestor) {
        this.requestor = requestor;
    }
    get baseUrl() {
        return "https://catalog-transition.products.vpsvc.com/api/";
    }
}
export var ProductCatalogConfigEndpoint;
(function (ProductCatalogConfigEndpoint) {
    ProductCatalogConfigEndpoint[ProductCatalogConfigEndpoint["GET_COMPATIBLE_OPTIONS"] = 0] = "GET_COMPATIBLE_OPTIONS";
})(ProductCatalogConfigEndpoint || (ProductCatalogConfigEndpoint = {}));
//# sourceMappingURL=ProductCatalogServiceConfig.js.map